import { Icons } from '@commenda/kakashi';
import { TaskStatus } from '@prisma/client';

interface ITaskStepIndicatorProps {
  status: TaskStatus;
  isCurrent: boolean;
  isFailed?: boolean;
}

export const TaskStepIndicator = ({
  status,
  isCurrent,
  isFailed = false,
}: ITaskStepIndicatorProps) => {
  if (isFailed) {
    return (
      <div className="flex size-5 shrink-0 items-center justify-center rounded-full bg-utility-error-500">
        <Icons.XClose className="size-3 text-white" />
      </div>
    );
  }

  if (status === TaskStatus.COMPLETED) {
    return (
      <div className="size-5 rounded-full bg-utility-success-500 flex items-center justify-center shrink-0">
        <Icons.Check className="size-3 text-white" />
      </div>
    );
  }

  if (status === TaskStatus.IN_PROGRESS || isCurrent) {
    return (
      <div className="size-4 rounded-full border-4 border-fg-brand bg-bg-primary shrink-0" />
    );
  }

  return (
    <div className="size-4 rounded-full border-2 border-border-secondary bg-bg-primary shrink-0" />
  );
};
